import { ModeratorResponse } from "../types/api/moderators";
import { MetricType } from "../types/api/metrics/metricsType";

export function compareModerators(
  moderator1: ModeratorResponse,
  moderator2: ModeratorResponse
): boolean {
  // Сравнение основных полей
  if (
    moderator1.id !== moderator2.id ||
    moderator1.createdAt !== moderator2.createdAt ||
    moderator1.username !== moderator2.username ||
    moderator1.password !== moderator2.password ||
    moderator1.name !== moderator2.name ||
    moderator1.role !== moderator2.role
  ) {
    return false;
  }

  // Сравнение permissions
  const permissions1 = moderator1.permissions;
  const permissions2 = moderator2.permissions;

  if (
    permissions1.canViewUsers !== permissions2.canViewUsers ||
    permissions1.canBlockUsers !== permissions2.canBlockUsers ||
    permissions1.canViewAds !== permissions2.canViewAds ||
    permissions1.canBlockAds !== permissions2.canBlockAds ||
    permissions1.canApproveAds !== permissions2.canApproveAds ||
    permissions1.canViewAppeals !== permissions2.canViewAppeals ||
    permissions1.canReplyAppeals !== permissions2.canReplyAppeals ||
    permissions1.canViewProposals !== permissions2.canViewProposals ||
    permissions1.canViewComplaints !== permissions2.canViewComplaints ||
    permissions1.canViewDashboardMetrics !==
      permissions2.canViewDashboardMetrics
  ) {
    return false;
  }

  // Сравнение metricsPermissions
  const metricsKeys1 = Object.keys(
    permissions1.metricsPermissions
  ) as MetricType[];
  const metricsKeys2 = Object.keys(
    permissions2.metricsPermissions
  ) as MetricType[];

  if (metricsKeys1.length !== metricsKeys2.length) {
    return false;
  }

  for (const key of metricsKeys1) {
    if (
      permissions1.metricsPermissions[key] !==
      permissions2.metricsPermissions[key]
    ) {
      return false;
    }
  }

  return true;
}
